import { Navbar, Carousel, Minter, About, Traits, Roadmap, Team, FAQ } from './containers';


export default function App() {
  return (
    <>
       <Navbar/>
       <Carousel/>
       <Minter />
       <About />
       <Traits />
       <Roadmap />
       <Team />
       <FAQ />
    </>
  );
}


